import { MODULE_RESOURCE } from './type';

export { default as OrderList } from './lib/components/orders/OrderList';
export { default as OrderCreate } from './lib/components/orders/OrderCreate';
export { default as OrderEdit } from './lib/components/orders/OrderEdit';
export { default as OrderShow } from './lib/components/orders/OrderShow';

export { default as CustomerInventoryList } from './lib/components/customer-inventories/CustomerInventoryList';
export { default as CustomerInventoryTransfer } from './lib/components/customer-inventories/CustomerInventoryTransfer';
export { SportswearSectionV2Fields, SportswearSectionV2InputLabel } from './lib/components/customer-inventories/SportswearSectionV2Input';

export { MedusaContextProvider, useMedusaContext } from './lib/providers/MedusaContext';
export { createDataProvider } from './lib/providers/data-provider';

export { default as translations } from './lib/translations';

export { MODULE_RESOURCE };

export const MODULE_RESOURCES_ARR = Object.values(MODULE_RESOURCE);
